import { calcInitial, colorStrings, mediaQueriesBP } from "@dillon/Utilities/variables";
import { footerStyles as styles } from "@insite/content-library/Pages/Footer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        position: relative;
        margin-top: 60px;

        &::before {
            content: "";
            border-top: 1px solid ${getColor(colorStrings.commonBorder)};
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            height: 1px;
            z-index: 1;
        }

        ${mediaQueriesBP.minXLG} {
            &::before {
                left: ${calcInitial};
                right: ${calcInitial};
            }
        }

        &&& {
            padding-top: 0;
            padding-bottom: 0;
        }
    `,
};
